module.exports = __webpack_public_path__ + "img/logo_white_large.a03fd87b.png";